import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import { isEmptyVal, isNotEmpty, displayField } from "../../../utils/helpers";

const OwnerCell = ({ rowData, ...props }: { rowData: any }) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  const speaker = (
    <Popover title={t("OWNER")}>
      <p>
        <b>{t("NAME")} :</b> {displayField(rowData.prime_comp_admin)}
      </p>
      <p>
        <b>{t("EMAIL")} :</b>
        {displayField(rowData.prime_comp_admin_email)}
      </p>
      <p>
        <b>{t("PHONE")} :</b>
        {displayField(rowData.prime_comp_admin_phone)}
      </p>
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper placement="top" speaker={speaker} preventOverflow={true}>
        <a>{displayField(rowData.prime_comp_admin)}</a>
      </Whisper>
    </Cell>
  );
};

export default OwnerCell;
